import { Cursor } from './Cursor';
import { PageManager } from './PageManager';

export class LayoutEngine {
    constructor(doc) {
        this.doc = doc;
        this.cursor = new Cursor(36, 36);
        this.pageManager = new PageManager(doc);
    }

    getDoc() {
        return this.doc;
    }

    getCursor() {
        return this.cursor;
    }

    getPageManager() {
        return this.pageManager;
    }

    space(amount) {
        this.cursor.space(amount);
        return this;
    }

    ensureSpace(requiredHeight, options = {}) {
        const limit = options.limit || 735;
        const resetY = options.resetY !== undefined ? options.resetY : 36;
        const drawTermsCard = options.drawTermsCard || false;

        if (this.cursor.getY() + requiredHeight > limit) {
            this.pageManager.addPage({ drawTermsCard, resetYTo: resetY });
            this.cursor.setY(resetY);
            if (options.onPageBreak) {
                options.onPageBreak(this);
            }
            return true;
        }
        return false;
    }

    section(options = {}, renderFn) {
        const marginTop = options.marginTop || 0;
        const marginBottom = options.marginBottom || 0;
        const minHeight = options.minHeight || 0;

        if (marginTop > 0) {
            this.cursor.space(marginTop);
        }

        if (minHeight > 0) {
            this.ensureSpace(minHeight, options);
        }

        const startY = this.cursor.getY();
        if (typeof renderFn === 'function') {
            const endY = renderFn(this.cursor, this.doc, this);
            if (typeof endY === 'number') {
                this.cursor.setY(endY);
            }
        }

        if (marginBottom > 0) {
            this.cursor.space(marginBottom);
        }

        return this;
    }
}
